import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import JobsFiltersForm from './JobsFiltersForm';
import ActionButton from '@core/components/actionbutton/ActionButton';
import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';

import useWindowSize from 'hooks/use-windowSize';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import FilterIcon from 'assets/icons/filter.svg';

import classes from './JobsFilters.module.scss';

const JobsFilters = ({ filterChangeHandler, toast }) => {
    const { mobileDevice } = useWindowSize();
    const { show, showModal, destroyModal } = UseModal();

    const router = useRouter();

    const [values, setValues] = useState({
        favorite: '',
        employment_type: '',
        job_mode: '',
        job_level: '',
        date_posted: '',
        ...router.query
    });

    useEffect(() => {
        if (!mobileDevice) {
            filterChangeHandler(values);
        }
    }, [JSON.stringify(values)]);

    const handleModalApplyBtn = (e) => {
        e.preventDefault();
        filterChangeHandler(values);
        destroyModal();        
    };

    return (
        <>
            <div className={`${classes['job-board-filter']}`}>
                <div className="container d-flex flex-row flex-md-column flex-xl-row align-items-center align-items-md-start  justify-content-between">
                    <h5 className='m-0'>Jobs</h5>
                    <div>
                        {mobileDevice ? (
                            <ActionButton kind="simple" onClick={showModal}>
                                <FilterIcon /> Filters
                            </ActionButton>
                        ) : (
                            <></>
                            // <JobsFiltersForm metadata={metadata} values={values} setValues={setValues} />
                        )}
                    </div>
                </div>
            </div>
            {!mobileDevice && (
                <div className={`${classes['filter-wrapper']} container`}>
                    <JobsFiltersForm values={values} setValues={setValues} toast={toast} />
                </div>
            )}
            <Modal title={'Filters'} closeHandler={destroyModal} show={show} type={MOBILE_SLIDE_UP}>
                <JobsFiltersForm values={values} setValues={setValues} toast={toast} expandedFilters />
                <ActionButton onClick={handleModalApplyBtn} className="mt-4">
                    Apply Filters
                </ActionButton>
            </Modal>
        </>
    );
};

export default JobsFilters;
